module.exports = __webpack_public_path__ + "static/media/business-card-demo.72d67fa9.png";